import accountTypesJson from './content/account-types.json';

export const accountTypesMock = {
    layoutType: 2,
    data: {
        name: 'account-types',
        areasList: [
            {
                id: 1,
                name: 'AccountTypesPage',
                componentName: 'Comp:AccountTypesPage',
                content: JSON.stringify(accountTypesJson)
            }
        ]
    }
};
